import { useTheme as muiUseTheme } from '@mui/material/styles';
import baseMakeStyles, { CustomMakeStyles } from '@shared/theme/makeStyles';
import { SetCssVarHook, useBaseSetCssVar } from '@shared/theme/predefinedVars';
import baseStyled, { CustomStyled } from '@shared/theme/styled';
import cssVars from './cssVars';
import { MobileTheme } from './types';

export const makeStyles = baseMakeStyles as CustomMakeStyles<MobileTheme>;

export const styled = baseStyled as CustomStyled<MobileTheme>;

export const useTheme = muiUseTheme as () => MobileTheme;

export { default as buildTheme } from './buildTheme';

export const useSetCssVar = useBaseSetCssVar as SetCssVarHook<keyof typeof cssVars>;

export type ColorPaletteName =
  | 'primary'
  | 'job'
  | 'education'
  | 'hobby'
  | 'neutrals'
  | 'success'
  | 'error'
  | 'warning'
  | 'info';
